if (!customElements.get('swatches-card-product')) {
  class SwatchesCardProduct extends HTMLElement {
    selectors = {
      swatch: '[data-color]'
    }

    constructor() {
      super();
    }

    connectedCallback() {
      this.swatches = this.querySelectorAll(this.selectors.swatch);

      this.swatches.forEach(swatch => {
        swatch.addEventListener('click', () => this.handleSwatchClick(swatch));
      })
    }

    handleSwatchClick(swatch) {
      const newImage = swatch.dataset.image;
      if (newImage) {
        const card = swatch.closest('card-product');
        try {
          card?.updateImage(newImage)

        } catch (error) {
          console.warn(error)
        }
      }

      this.swatches.forEach(swatch => swatch.classList.remove('is-active'));
      swatch.classList.add('is-active');
    }
  }
  customElements.define('swatches-card-product', SwatchesCardProduct);
}
